import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProviders } from "@/components/app-providers";
import { ProtectedRoute } from "@/components/protected-route";
import { DashboardLayout } from "@/components/dashboard-layout";
import { DashboardPage } from "@/pages/dashboard";
import { UsersPage } from "@/pages/users";
import { VideosPage } from "@/pages/videos";
import { SubscriptionsPage } from "@/pages/subscriptions";
import { AnalyticsPage } from "@/pages/analytics";
import { SystemPage } from "@/pages/system";
import { SettingsPage } from "@/pages/settings";
import { SignInPage } from "@/pages/sign-in";
import { SignUpPage } from "@/pages/sign-up";
import { PlansPage } from "@/pages/plans";
import "./index.css";

import { Toaster } from "@/components/ui/sonner";

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />

          {/* Protected routes */}
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/plans" element={<PlansPage />} />
            {/* <Route path="/analytics" element={<AnalyticsPage />} /> */}
            {/* <Route path="/system" element={<SystemPage />} /> */}
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          
          {/* Fallback to sign-in */}
          {/* We redirect to / because that's where the dashboard is, and ProtectedRoute will handle auth check */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      <Toaster />
      </BrowserRouter>
    </AppProviders>
  );
}

export default App;
